/** Shared display formatting helpers. */

/** Two-digit editorial folio index: 1 → "01". */
export function formatFolio(n: number): string {
  return String(n).padStart(2, "0");
}
